import ProductFilters from "~/features/search/components/ProductFilters";
import ProductGrid from "@/ProductGrid";
import ShopContext, { ShopProvider } from "#/context/ShopContext";
import { useParams } from 'react-router-dom';
import { useContext, useEffect } from 'react';
import ProductPagination from "../components/ProductPagination";
import ProductSort from "../components/ProductSort";
import CategoriesCarousel from "../components/CategoriesCarousel";
import CategoryProductGrid from "../../../components/CategoryProductGrid";
const ShopAll = () => {


  const { categoryName } = useParams();

  const {
    catProd,
    getProductsByCategory,
    queryProductsApi,
    filters,
    selectedFilters,
    getCategories,
    sort
  } = useContext(ShopContext)

  useEffect(() => {
    if (categoryName) {
      getProductsByCategory(decodeURIComponent(categoryName))
      getCategories(undefined, categoryName)
    }
  }, [])
  const { last_page, current_page } = catProd.products

  return (<>
    {categoryName &&
      <CategoriesCarousel />

    }
    <div className='flex product-page'>
      <ProductFilters />
      <div className='product-grid-container flex column'>
        <ProductSort />
        <ProductPagination
          style={{
            marginTop: 12
          }}
          size={last_page}
          current={current_page}
          handleClick={page => queryProductsApi(undefined, selectedFilters, page, sort)}
        />
        <ProductGrid
          list={catProd.products.list}
        />
        {
          last_page > 1 &&
          <ProductPagination
            style={{
              marginTop: 12
            }}
            size={last_page}
            current={current_page}
            handleClick={page => queryProductsApi(undefined, selectedFilters, page, sort)}
          />
        }
      </div>
    </div>
      {
        (categoryName == '620' || categoryName == 'ready-for-the-road-police-vehicles')
        &&
        <CategoryProductGrid
          list={catProd.secondary_products.list}
        />
      }
  </>

  )
}

const ShopAllPage = () =>
  <ShopProvider>
    <ShopAll />
  </ShopProvider>


export default ShopAllPage;

